import type { ReactNode } from 'react';
import { useAuth } from './auth-context';

export function PermissionGuard({
  permission,
  children,
  fallback = null
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { hasPermission } = useAuth();
  return hasPermission(permission) ? children : fallback;
}

export function RequireModule({
  moduleId,
  permission,
  children,
  fallback
}: {
  moduleId: string;
  permission?: string;
  children: ReactNode;
  fallback: ReactNode;
}) {
  const { session, hasPermission } = useAuth();
  const enabled = session.modules.some(
    (module) =>
      module.id === moduleId &&
      module.enabled &&
      (module.requiredPermissions.length === 0 ||
        module.requiredPermissions.some((required) => hasPermission(required)))
  );
  return enabled && hasPermission(permission) ? children : fallback;
}
